import { IconProps } from "./types";

export default function IcoNotification({
	color = "black",
	width = "18",
	height = "21"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 18 21"
			fill="none"
		>
			<g clipPath="url(#clip0_636_3422)">
				<path
					d="M9.2501 0.5C8.5587 0.5 8.0001 1.05859 8.0001 1.75V2.44922C5.16807 2.89844 3.0001 5.35156 3.0001 8.3125V9.61719C3.0001 11.3906 2.39463 13.1133 1.28917 14.4961L0.707134 15.2266C0.480572 15.5078 0.437603 15.8945 0.593853 16.2188C0.750103 16.543 1.07823 16.75 1.4376 16.75H17.0626C17.422 16.75 17.7501 16.543 17.9064 16.2188C18.0626 15.8945 18.0196 15.5078 17.7931 15.2266L17.211 14.5C16.1056 13.1133 15.5001 11.3906 15.5001 9.61719V8.3125C15.5001 5.35156 13.3321 2.89844 10.5001 2.44922V1.75C10.5001 1.05859 9.94151 0.5 9.2501 0.5ZM9.2501 4.25H9.5626C11.8048 4.25 13.6251 6.07031 13.6251 8.3125V9.61719C13.6251 11.4883 14.1681 13.3125 15.1759 14.875H3.32432C4.33213 13.3125 4.8751 11.4883 4.8751 9.61719V8.3125C4.8751 6.07031 6.69542 4.25 8.9376 4.25H9.2501ZM11.7501 18H9.2501H6.7501C6.7501 18.6641 7.01182 19.3008 7.48057 19.7695C7.94932 20.2383 8.58604 20.5 9.2501 20.5C9.91417 20.5 10.5509 20.2383 11.0196 19.7695C11.4884 19.3008 11.7501 18.6641 11.7501 18Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_636_3422">
					<path d="M0.5 0.5H18V20.5H0.5V0.5Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
